import React from 'react';

export interface IItemChat {
  icon: any;
  name: string;
  lastMessage: string;
}

interface Props {
  chat: IItemChat;
}

const ListItem = (props: Props) => {
  return (
    <div className='list-item-wrapper'>
      <div className='item-icon'>
        <img
          // eslint-disable-next-line max-len
          src='https://png.pngtree.com/png-vector/20191101/ourmid/pngtree-cartoon-color-simple-male-avatar-png-image_1934459.jpg'
          alt='user icon'
        />
      </div>
      <div className='item-content'>
        <div className='item-username'>
          <p>{props.chat.name}</p>
        </div>
        <div className='item-message'>
          <p>{props.chat.lastMessage}</p>
        </div>
      </div>
    </div>
  );
};

export default ListItem;
